import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import {
  FormCheckBox,
  FormInput,
  SchoolGradeSelect,
  SchoolSubjectSelect,
} from 'shared'
import { COLORS } from 'styling/variables'
import styled from '@emotion/styled'
import { SubmitButtonLab } from 'platforms/kyoso-lab/shared'
import { useTranslation } from 'react-i18next'
import { getAllKyosoTypes } from 'services/shared'
import { yearValidator } from 'utils/helpers/validators'

export function FiltrationBundlesFormMobile({ toggleFilter, submitCallback }) {
  const {
    reset,
    register,
    control,
    getValues,
    handleSubmit,
    trigger,
    setValue,
    formState,
  } = useForm({
    mode: 'onSubmit',
  })
  const { t } = useTranslation()

  const onSubmitFilter = (data) => {
    submitCallback({
      schoolGrade: data.schoolGrade,
      schoolSubject: data.schoolSubject,
      year: data.year || null,
    })
  }

  const resetDataHandler = () => {
    const defaultValues = {
      schoolGrade: null,
      schoolSubject: null,
    }
    setIsChecked(false)
    reset(defaultValues)
    submitCallback(null)
  }

  return (
    <FormLayout onSubmit={handleSubmit(onSubmitFilter)}>
      <h2>
        <i className="fas fa-filter"></i>
        {t('lab:Kyoso:FiltrationTitle')}
      </h2>

      <FormInput
        customCss={{ marginBottom: '0' }}
        id="year"
        label="lab:Kyoso:FilterYear"
        type="number"
        name="year"
        onChange={() => trigger('year')}
        register={register({
          validate: {
            yearValidation: (value) => {
              if (value) {
                return yearValidator(value)
              }
            },
          },
        })}
        error={formState.errors.year}
      />

      <SchoolSubjectSelect
        customCss={{ marginBottom: '0' }}
        id="schoolSubject"
        label="lab:Kyoso:FilterSchoolSubject"
        name="schoolSubject"
        onChange={() => trigger('schoolSubject')}
        setValue={setValue}
        getValues={getValues}
        control={control}
        isClearable={true}
        defaultValue={null}
      />

      <SchoolGradeSelect
        customCss={{ marginBottom: '0' }}
        id="schoolGrade"
        label="lab:Kyoso:FilterSchoolGrade"
        name="schoolGrade"
        isClearable={true}
        setValue={setValue}
        getValues={getValues}
        onChange={() => trigger('schoolGrade')}
        control={control}
        defaultValue={null}
      />

      <SubmitButtonLab
        className="black"
        type="submit"
        customCss={{ alignSelf: 'end' }}
      >
        {t('lab:Kyoso:SubmitFilterButton')}
      </SubmitButtonLab>

      <SubmitButtonLab
        className="white"
        type="reset"
        onClick={() => resetDataHandler()}
        customCss={{
          alignSelf: 'end',
          marginTop: '20px',
          i: {
            marginRight: '10px',
          },
        }}
      >
        <i className="fas fa-times"></i>
        {t('lab:Kyoso:ClearFilterButton')}
      </SubmitButtonLab>
      <button type="button" className="button" onClick={() => toggleFilter()}>
        <i className="fas fa-times"></i>
      </button>
    </FormLayout>
  )
}

const FormLayout = styled('form')({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  border: ` 2px solid ${COLORS.secBlack} `,
  padding: '15px',
  borderRadius: '5px',
  position: 'relative',

  '& h2': {
    textAlign: 'center',
    marginBottom: '20px',
    marginTop: '5px',
    i: {
      marginRight: '10px',
    },
  },

  '& label': {
    marginBottom: '20px',
  },

  '& .button': {
    cursor: 'pointer',

    backgroundColor: '#fff',
    border: 'none',
    alignSelf: 'center',
    position: 'absolute',
    top: '5px',
    right: '5px',

    '& i': {
      fontSize: '30px',
      color: COLORS.mainGray,
    },
  },
})
